import { Layout } from 'antd';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { Path } from '@/enums';

const { Content } = Layout;

export const QuestionnaireLayout = () => {
  const { token } = useAuth();

  if (!token) {
    return <Navigate to={Path.Login} replace />;
  }

  return (
    <Layout
      style={{
        position: 'relative',
        height: '100vh',
        minHeight: '100vh',
        maxHeight: '100vh',
        overflow: 'hidden',
      }}
    >
      <Content
        style={{
          display: 'flex',
          background: 'linear-gradient(#fffef9 0, #c7d2c0 100%)',
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
};
